export const getTotalQuantityInOtherParcels = (item, currentParcel) =>
  Object.keys(item?.parcels ?? {}).reduce((acc, parcelId) => {
    if (parcelId === currentParcel?.id) {
      return acc;
    }

    const parcel = item.parcels[parcelId];
    return acc + (parcel?.item_ids?.length ?? 0);
  }, 0);

export default getTotalQuantityInOtherParcels;
